export default __webpack_public_path__ + "static/media/H4010.1.03d6b674.mp3";